export const c_tree_view_m_compact_base_border_Left_offset = {
  "name": "--pf-c-tree-view--m-compact--base-border--Left--offset",
  "value": "1rem",
  "var": "var(--pf-c-tree-view--m-compact--base-border--Left--offset)"
};
export default c_tree_view_m_compact_base_border_Left_offset;